import React, { useState, useEffect } from 'react';
import { Drawer, DrawerContent, DrawerSelectEvent } from '@progress/kendo-react-layout';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { JobTitleMapping } from '../features/admin/jobTitleMapping/JobTitleMapping';
import { ApproversConfiguration } from '../features/admin/approvers/ApproversConfiguration';
import { Administration } from '../features/admin/Administration';
import '../TicketEasy.css';
import { Messages } from '../features/messages/Messages';
import { TicketEasyAppBar } from './TicketEasyAppBar';
import { Box } from '@mui/material';
import { buildMessageViewUrl } from '../utils/navigationUtils';

interface DrawerItem {
    text: string;
    icon: string;
    route: string;
}

const LeftMenuDrawer: React.FC = () => {
    const [expanded, setExpanded] = useState<boolean>(false);
    const [selectedRoute, setSelectedRoute] = useState<string>('');
    const location = useLocation();
    const navigate = useNavigate();
    
    const items: DrawerItem[] = [
        { text: 'Messages', icon: 'k-i-email', route: 'messages' },
        { text: 'Admin', icon: 'k-i-gear', route: 'admin' },
        { text: 'Job Map', icon: 'k-i-building-blocks', route: 'job-title-mapping' },
        { text: 'Approvers', icon: 'k-i-user', route: 'approvers' }            
    ];

    useEffect(() => {
        const currentPath = location.pathname;
        // Set the selected route based on the current path
        const matchingItem = items.find(item => currentPath.includes(item.route));
        if (matchingItem) {
            setSelectedRoute(matchingItem.route);
        } else {
            // Default to messages if no match
            setSelectedRoute('/messages');
        }
    }, [location.pathname]);

    const toggleDrawer = (): void => {
        setExpanded(!expanded);
    };    const handleSelect = (e: DrawerSelectEvent): void => {
        const item = items[e.itemIndex];
        setSelectedRoute(item.route);
        setExpanded(false);
        
        // If navigating to messages, use the allMessages view type by default
        if (item.route === 'messages') {
            navigate(buildMessageViewUrl(item.route, 'allMessages'));
        } else {
            navigate(item.route);
        }
    };    return (
        <Box className="ticketEasy-module" sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', overflow: 'hidden' }}>
            <TicketEasyAppBar toggleDrawer={toggleDrawer} />
            <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden', width: '100%' }}>
                <Drawer
                    className="messages-container k-drawer"
                    expanded={expanded}
                    mode="push"
                    mini={true}
                    width={145}
                    items={items.map(item => ({
                        text: item.text,
                        icon: item.icon,
                        selected: item.route === selectedRoute
                    }))}
                    onSelect={handleSelect}
                >
                    <DrawerContent>
                        <Box sx={{ 
                            height: '100%', 
                            overflow: 'auto', 
                            width: '100%', 
                            maxWidth: '1200px',
                            margin: '0 auto',
                            padding: '0 16px',
                            boxSizing: 'border-box'
                        }}>
                            <Routes>
                                <Route path="messages" element={<Messages />} />
                                <Route path="admin" element={<Administration />} />
                                <Route path="job-title-mapping" element={<JobTitleMapping />} />
                                <Route path="approvers" element={<ApproversConfiguration />} />
                            </Routes>
                        </Box>
                    </DrawerContent>
                </Drawer>
            </Box>
        </Box>
    );
};

export default LeftMenuDrawer;